// eslint-disable-next-line no-unused-vars
import { Subject } from 'rxjs';
const _errorSub = new Subject<string>();

export const publicErrorService = {
  onError: (error: string) => _errorSub.next(error),
  onError$: _errorSub.asObservable(),
};
